<template>
  <el-row>
    <el-col class="mb-2">
      Утасны дугаараар хайх
    </el-col>
    <el-col :span=6>
      <el-input v-model="phone" placeholder="Хайх утасны дугаараа оруулна уу" type="number"></el-input>
    </el-col>
    <el-col :span="2" class="ml-1 mb-5">
      <el-button type="success" @click="getHistory(this.phone)"><font-awesome-icon icon="fa-search" /></el-button>
    </el-col>
    <el-col>
      <el-table :data="history">
        <el-table-column type="index" label="№"></el-table-column>
        <el-table-column prop="phone" label="Утасны дугаар"></el-table-column>
        <el-table-column prop="sms_text" label="Илгээсэн текст"></el-table-column>
        <el-table-column label="Огноо">
          <template v-slot:default="scope">
            {{ scope.row.createdAt.split('T')[0] }}
          </template>
        </el-table-column>
        <el-table-column label="Төлөв">
          <template v-slot:default="scope">
            <el-tag v-if="scope.row.type && scope.row.type === 'success'" type="success">{{ scope.row.type }}</el-tag>
            <el-tag v-if="scope.row.type && scope.row.type != 'success'" type="error">{{ scope.row.type }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Тайлбар" prop="error">
        </el-table-column>
      </el-table>
      <el-pagination
      @current-change="handlePageChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="totalRecords"
      layout="total, prev, pager, next, jumper"
      style="margin-top: 20px; text-align: right;" />
    </el-col>
  </el-row>
  </template>

<script>
import services from '../services'
import { mapActions, mapState } from 'vuex'
import { ElMessage } from 'element-plus'

export default {
  name: 'MessageHistoryDialog',
  data () {
    return {
      history: [],
      phone: null,
      currentPage: 1,
      pageSize: 100,
      totalRecords: null
    }
  },
  computed: {
    ...mapState(['messageHistoryDialog'])
  },
  created () {
    this.getHistory()
  },
  methods: {
    ...mapActions(['setMessageHistory']),
    handleClose () {
      this.formData = {}
      this.setMessageHistory(false)
    },
    async getHistory (data) {
      try {
        this.$root.fullscreenLoading = true
        const response = await services.get('messageHistory', {
          params: {
            page: this.currentPage,
            limit: this.pageSize,
            phone: data
          }
        })
        if (response.type === 'success') {
          this.history = response.data
          this.totalRecords = response.total
          this.totalPages = response.totalPages
          this.$root.fullscreenLoading = false
          if (!response.data.length) {
            ElMessage.warning('Өгөгдөл олдсонгүй!')
            this.$root.fullscreenLoading = false
          }
        } else {
          ElMessage.error('Өгөгдөл олдсонгүй!')
          this.$root.fullscreenLoading = false
        }
      } catch (error) {
        ElMessage.error(`Өгөгдөл татхад алдаа гарлаа: ${error.message}`)
        this.$root.fullscreenLoading = false
      }
    },
    handlePageChange (page) {
      this.currentPage = page
      this.getHistory()
    },
    async searchHistory () {
      try {
        const response = await services.get('messageSearch', {
          params: {
            page: this.currentPage,
            limit: this.pageSize,
            phone: this.phone
          }
        })
        if (response.type === 'success') {
          this.history = response.data
          this.totalRecords = response.total
          this.totalPages = response.totalPages
        } else {
          ElMessage.error('Өгөгдөл олдсонгүй!')
        }
      } catch (error) {
        ElMessage.error(`Өгөгдөл татхад алдаа гарлаа: ${error.message}`)
      }
    }
  }
}

</script>

<style scoped>
</style>
